import styled from "@emotion/styled";
import React from "react";
import { openExternalUrl } from "../external_link";
import { AppButton } from "./Generic/AppButton";
import { default as DownloadIcon } from "/public/assets/download_icon.svg?react";

interface Props {
  src: string;
}

function DocumentDownloadButton(props: Props) {
  const handleClickDownload = React.useCallback(() => {
    openExternalUrl(props.src);
  }, [props.src]);

  return (
    <DocumentDownloadButton.Button onClick={handleClickDownload} variant="soft" color="primary">
      <DownloadIcon />
    </DocumentDownloadButton.Button>
  );
}

DocumentDownloadButton.Button = styled(AppButton)`
  background-color: white;
  color: #888;
  border: none;
  position: relative;
  left: 10px;
  bottom: 45px;
  width: 35px;
  height: 35px;
  z-index: 2;

  svg {
    flex-shrink: 0;
    padding: 0;
  }
`;

export default DocumentDownloadButton;
